import React, { useContext, useRef, useState, useTransition } from "react";
import "./CadastrarCertificado.scss";
import GlobalContext from "@context/GlobalContext";
import useLoading from "@hooks/useLoading";
import EndPointServices from "@services/ApiServices";
import Button from "@components/button/Button";
import { useForm } from "react-hook-form";
import Input from "@components/input/Input";
import UtilServices from "@services/UtilServices";
import MessageServices from "@services/MessageServices";

const CadastrarCertificado = () => {
  const [isPending, startTransition] = useTransition();

  useLoading(isPending);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({});

  const fileInputRef = useRef(null);

  //Variaveis Padrões
  const [state] = useContext(GlobalContext);

  //
  const [inputcertificado, setInputCertificado] = useState("");
  const [base64, setBase64] = useState("");

  async function handleUploadCertificado(event) {
    let file;
    file = event.target.files[0];
    setInputCertificado(file?.name);
    fileInputRef.current.value = "";

    let base64 = await UtilServices.readFileAsBase64B(file);
    setBase64(base64);
  }

  function handleSubmitCadastrar(e) {
    if (!inputcertificado) {
      MessageServices.ShowWarning("O arquivo certificado é obrigatório!");
      return;
    }
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        base64: base64,
        senha: e.senha,
        nomecertificado: inputcertificado,
      };

      var retornoapi = await EndPointServices.Cliente_CadastrarCertificado(
        data,
      );
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess(
          "Cadastro do certificado realizado com sucesso !",
        );
        reset();
        setInputCertificado("");
        setBase64("");
      }
    });
  }

  return (
    <div className="cadastrarcertificado row">
      <form onSubmit={handleSubmit(handleSubmitCadastrar)} className="row mb-4">
        <div className="col-md-6 col-12 mt-2">
          <Input
            title="Upload Certificado"
            placeholder="Caminho do Certificado"
            name="caminhodoarquivo"
            maxLength="5"
            type="number"
            value={inputcertificado}
            disabled
            button
            iconButton="Upload"
            titleButton=""
            typeButton="button"
            onClickButton={() => {
              fileInputRef.current.click();
            }}
            tooltip
            tooltipDescricao="Realize o upload do certificado .pfx"
            tooltipId="tooltip-001"
            tooltipIconColor="#FFDF5E"
            tooltipIcon={<i class="fa-regular fa-question"></i>}
          />
        </div>
        <div className="col-md-3 col-12 mt-2">
          <Input
            title="Senha do Certificado"
            placeholder="Senha"
            type="password"
            setValue={setValue}
            register={register}
            errors={errors}
            registerProps={{
              required: "Senha é obrigatório",
            }}
            name="senha"
          />
        </div>
        <div className="mt-3">
          <Button
            nome="Cadastrar"
            icon="<i class='fa-solid fa-plus'></i>"
            theme="2"
          />
        </div>
      </form>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(event) => {
          handleUploadCertificado(event);
        }}
        accept=".pfx"
      />
    </div>
  );
};

export default CadastrarCertificado;
